
import { Button } from '@/components/ui/button';

interface Supplier {
  id: string;
  name_ar: string;
  name_en: string;
  employee_name_ar: string;
  employee_name_en: string;
  mobile: string;
  country: string;
  departments: string;
  email: string;
  access_permission: boolean;
  created_at: string;
  updated_at: string;
}

interface SupplierFormActionsProps {
  supplier: Supplier | null;
  loading: boolean;
  onClose: () => void;
}

export function SupplierFormActions({ supplier, loading, onClose }: SupplierFormActionsProps) {
  return (
    <div className="flex justify-end gap-2">
      <Button
        type="button"
        variant="outline"
        onClick={onClose}
        disabled={loading}
      >
        إلغاء
      </Button>
      <Button type="submit" disabled={loading}>
        {loading ? 'جاري الحفظ...' : supplier ? 'تحديث' : 'إضافة'}
      </Button>
    </div>
  );
}
